export const perm_city_dict = {
  Ashgabat: 1,
  Dushanbe: 2,
  Namangan: 3,
  Osh: 4,
  Petropavlovsk: 5,
};
